import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CancelCardStackRoutes, CancelCardStackScreenProps } from './type';
import { CancelCardWebOneScreen } from './CancelCardWebOne.screen';
import { CancelCardNativeOneScreen } from './CancelCardNativeOne.screen';

export const CancelCardConfirm: React.FC<CancelCardStackScreenProps<CancelCardStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, data, account, tab, record, func, onReturnData, refresh, onChangeView } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <CancelCardNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        account={account}
        tab={tab}
        record={record}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <CancelCardWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      account={account}
      tab={tab}
      record={record}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
    />
  );
};
